document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-qty]');
  if (!b) return;
  var input = b.parentNode.querySelector('input');
  var cart = !!input.closest('.cart__qty');
  input.value = Math.max(cart ? 0 : 1, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qty, 10));
  if (cart) input.dispatchEvent(new Event('change', { bubbles: true }));
});

/* Cart page: update quantities and totals instantly, no Update button needed */
(function () {
  var busy = false, queued = null;

  function refresh() {
    return fetch('/cart', { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('section.cart'), cur = document.querySelector('section.cart');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        var fl = doc.querySelector('.cartlink'), cl = document.querySelector('.cartlink');
        if (fl && cl) cl.innerHTML = fl.innerHTML;
      });
  }

  function send(line, qty) {
    if (busy) { queued = [line, qty]; return; }
    busy = true;
    var cur = document.querySelector('section.cart');
    if (cur) cur.style.opacity = '.6';
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(refresh).catch(function () { window.location.reload(); }).then(function () {
      busy = false;
      var c = document.querySelector('section.cart');
      if (c) c.style.opacity = '';
      if (queued) { var q = queued; queued = null; send(q[0], q[1]); }
    });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('.cart__qty input');
    if (!input) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) { qty = 1; input.value = 1; }
    send(parseInt(input.dataset.line, 10), qty);
  });

  /* Enter inside a quantity box applies the number instead of submitting the form */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest && e.target.closest('.cart__qty input')) {
      e.preventDefault();
      e.target.blur();
    }
  });
})();


/* Product image carousel: swipe, arrows, auto-scroll */
(function () {
  function init(g) {
    var track = g.querySelector('[data-track]');
    var n = track.children.length;
    if (n < 2) return;
    var speed = (parseInt(g.dataset.speed, 10) || 4) * 1000;
    var auto = g.dataset.autoplay === 'true' &&
      !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var timer = null, paused = false, visible = true;

    function index() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) {
      if (i >= n) i = 0;
      if (i < 0) i = n - 1;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function stop() { clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (auto && !paused && visible && !document.hidden) timer = setInterval(function () { go(index() + 1); }, speed);
    }

    g.addEventListener('click', function (e) {
      var b = e.target.closest('[data-dir]');
      if (!b) return;
      go(index() + parseInt(b.dataset.dir, 10));
      start();
    });
    g.addEventListener('mouseenter', function () { paused = true; stop(); });
    g.addEventListener('mouseleave', function () { paused = false; start(); });
    g.addEventListener('touchstart', function () { paused = true; stop(); }, { passive: true });
    g.addEventListener('touchend', function () { setTimeout(function () { paused = false; start(); }, 2500); }, { passive: true });
    document.addEventListener('visibilitychange', start);
    window.addEventListener('resize', function () { track.scrollLeft = index() * track.clientWidth; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; start(); }).observe(g);
    }
    start();
  }
  document.querySelectorAll('[data-gallery]').forEach(init);
})();
